import { usePecField } from 'components/form/final-form/hooks/useField'
import { useProcedimentosAutomaticosQuery } from 'graphql/hooks.generated'
import { isUndefinedOrNull } from 'util/checks'
import { metaPath } from 'util/metaPath'
import { v4 as uuidv4 } from 'uuid'
import { SoapState } from 'view/atendimentos/atendimento-individual/model'
import { ProcedimentoPlanoModel } from 'view/atendimentos/detail/soap/plano/components/ProcedimentoPlanoField'
import { ProcedimentoAutomatico } from 'view/atendimentos/model-atendimento'

const metaSigtap = metaPath<SoapState>().plano.intervencoesProcedimentos.procedimentos

export const useProcedimentoAutomatico = () => {
  const {
    data: { procedimentosAutomaticos },
  } = useProcedimentosAutomaticosQuery({
    fetchPolicy: 'cache-first',
  })

  // Plano - Intervenções e/ou procedimentos clínicos realizados - Sigtap
  const {
    input: { value: sigtap, onChange: onChangeSigtap },
  } = usePecField({ name: metaSigtap.absolutePath() })

  const addIntervencoesProcedimentosSigtap = (codigoProcedimento: string): void =>
    addProcedimento(codigoProcedimento, procedimentosAutomaticos, sigtap || [], onChangeSigtap)

  return { addIntervencoesProcedimentosSigtap }
}

const addProcedimento = (
  codigoProcedimento: string,
  procedimentosAutomaticos: ProcedimentoAutomatico[],
  values: ProcedimentoPlanoModel[],
  onChange: (value: ProcedimentoPlanoModel[]) => void
) => {
  const procedimentoAutomatico = createProcedimeto(codigoProcedimento, procedimentosAutomaticos)

  if (Array.isArray(values) && procedimentoAutomatico?.procedimento) {
    if (!values.find((item) => item?.procedimento?.codigo === procedimentoAutomatico.procedimento.codigo)) {
      values.push(procedimentoAutomatico)
      onChange(values)
    }
  }
}

const createProcedimeto = (
  procedimentoAutomatico: string,
  procedimentosAutomaticos: ProcedimentoAutomatico[]
): ProcedimentoPlanoModel => {
  const procedimento = procedimentosAutomaticos.find((item) => item.codigo === procedimentoAutomatico)

  return (
    !isUndefinedOrNull(procedimento) && {
      _id: uuidv4(),
      procedimento: procedimento,
      automatico: true,
    }
  )
}
